import Vue from 'vue';
import Router from 'vue-router';
// tslint:disable: quotemark

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () =>
        import(/* webpackChunkName: "main" */ './views/Main.vue'),
      children: [
        {
          path: 'noaccess',
          component: () =>
            import(/* webpackChunkName: "login" */ './views/NoAccess.vue')
        },
        {
          path: 'login',
          component: () =>
            import(/* webpackChunkName: "login" */ './views/Login.vue')
        },
        {
          path: 'setup2fa',
          component: () =>
            import(/* webpackChunkName: "setup2fa" */ './views/Setup2FA.vue')
        },
        {
          path: 'home',
          name: 'home',
          component: () =>
            import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        // {
        //   path: 'recover-password',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "recover-password" */ './views/PasswordRecovery.vue'
        //     )
        // },
        {
          path: 'reset-password',
          component: () =>
            import(
              /* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'
            )
        },
        {
          path: '/manage/groups',
          name: 'manage/groups',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Groepen',
                disabled: false,
                href: '/manage/groups'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-groups" */ './views/manage/groups/Overview.vue'
            )
        },
        {
          path: '/manage/groups/:id',
          name: 'manage/groupsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Groepen',
                disabled: false,
                href: '/manage/groups'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-groups-detail" */ './views/manage/groups/Detail.vue'
            )
        },
        {
          path: '/manage/users',
          name: 'manage/users',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Gebruikers',
                disabled: false,
                href: '/manage/users'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-users" */ './views/manage/users/Overview.vue'
            )
        },
        {
          path: '/manage/users/:id',
          name: 'manage/usersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Gebruikers',
                disabled: false,
                href: '/manage/users'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-users-detail" */ './views/manage/users/Detail.vue'
            )
        },
        {
          path: '/manage/logging',
          name: 'manage/logging',
          meta: {
            breadCrumbs: [
              {
                text: 'Beheer',
                disabled: true
              },
              {
                text: 'Logging',
                disabled: false,
                href: '/manage/logging'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "manage-logging" */ './views/manage/logging/Overview.vue'
            )
        },
        {
          path: '/references/suppliers',
          name: 'references/suppliers',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Fabrikanten',
                disabled: false,
                href: '/references/suppliers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-suppliers" */ './views/references/suppliers/Overview.vue'
            )
        },
        {
          path: '/references/suppliers/:id',
          name: 'references/suppliersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Fabrikanten',
                disabled: false,
                href: '/references/suppliers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-suppliers-detail" */ './views/references/suppliers/Detail.vue'
            )
        },
        {
          path: '/references/addresses',
          name: 'references/addresses',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Adressen',
                disabled: false,
                href: '/references/addresses'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-addresses" */ './views/references/addresses/Overview.vue'
            )
        },
        {
          path: '/references/addresses/:id',
          name: 'references/addressesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Adressen',
                disabled: false,
                href: '/references/addresses'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-addresses-detail" */ './views/references/addresses/Detail.vue'
            )
        },
        {
          path: '/references/interventionpersons',
          name: 'references/interventionpersons',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Interventiepersonen',
                disabled: false,
                href: '/references/interventionpersons'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-interventionpersons" */ './views/references/interventionpersons/Overview.vue'
            )
        },
        {
          path: '/references/interventionpersons/:id',
          name: 'references/interventionpersonsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Interventiepersonen',
                disabled: false,
                href: '/references/interventionpersons'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-interventionpersons-detail" */ './views/references/interventionpersons/Detail.vue'
            )
        },
        {
          path: '/references/servers',
          name: 'references/servers',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Servers',
                disabled: false,
                href: '/references/servers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-servers" */ './views/references/servers/Overview.vue'
            )
        },
        {
          path: '/references/servers/:id',
          name: 'references/serversdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Servers',
                disabled: false,
                href: '/references/servers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-servers-detail" */ './views/references/servers/Detail.vue'
            )
        },
        {
          path: '/references/groups',
          name: 'references/groups',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Groepen',
                disabled: false,
                href: '/references/groups'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-groups" */ './views/references/groups/Overview.vue'
            )
        },
        {
          path: '/references/groups/:id',
          name: 'references/groupsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Groepen',
                disabled: false,
                href: '/references/groups'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-groups-detail" */ './views/references/groups/Detail.vue'
            )
        },
        {
          path: '/references/supervisors',
          name: 'references/supervisors',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Toezichters',
                disabled: false,
                href: '/references/supervisors'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-supervisors" */ './views/references/supervisors/Overview.vue'
            )
        },
        {
          path: '/references/supervisors/:id',
          name: 'references/supervisorsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Toezichters',
                disabled: false,
                href: '/references/supervisors'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-supervisors-detail" */ './views/references/supervisors/Detail.vue'
            )
        },
        {
          path: '/references/responsibles',
          name: 'references/responsibles',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Verantwoordelijken',
                disabled: false,
                href: '/references/responsibles'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-responsibles" */ './views/references/responsibles/Overview.vue'
            )
        },
        {
          path: '/references/responsibles/:id',
          name: 'references/responsiblesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Verantwoordelijken',
                disabled: false,
                href: '/references/responsibles'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-responsibles-detail" */ './views/references/responsibles/Detail.vue'
            )
        },
        {
          path: '/references/projectmanagers',
          name: 'references/projectmanagers',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Projectleiders',
                disabled: false,
                href: '/references/projectmanagers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-projectmanagers" */ './views/references/projectmanagers/Overview.vue'
            )
        },
        {
          path: '/references/projectmanagers/:id',
          name: 'references/projectmanagersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Projectleiders',
                disabled: false,
                href: '/references/projectmanagers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-projectmanagers-detail" */ './views/references/projectmanagers/Detail.vue'
            )
        },
        {
          path: '/references/documents',
          name: 'references/documents',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Documenten',
                disabled: false,
                href: '/references/documents'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-documents" */ './views/references/documents/Overview.vue'
            )
        },
        {
          path: '/references/documents/:id',
          name: 'references/documentsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Referenties',
                disabled: true
              },
              {
                text: 'Documenten',
                disabled: false,
                href: '/references/documents'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "references-documents-detail" */ './views/references/documents/Detail.vue'
            )
        },
        {
          path: '/devices/types',
          name: 'devices/types',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/devices/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-types" */ './views/devices/types/Overview.vue'
            )
        },
        {
          path: '/devices/types/:id',
          name: 'devices/typesdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/ SNC of andere",
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/devices/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-types-detail" */ './views/devices/types/Detail.vue'
            )
        },
        {
          path: '/devices/types/:type_id/lines/:id',
          name: 'devices/typelinesdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/devices/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-types-detail" */ './views/devices/typelines/Detail.vue'
            )
        },
        {
          path: '/devices/tests',
          name: 'devices/tests',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Testen',
                disabled: false,
                href: '/devices/tests'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-types" */ './views/devices/tests/Overview.vue'
            )
        },
        {
          path: '/devices/tests/:id',
          name: 'devices/testsdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Testen',
                disabled: false,
                href: '/devices/tests'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-tests-detail" */ './views/devices/tests/Detail.vue'
            )
        },
        {
          path: '/devices/tests/:test_id/lines/:id',
          name: 'devices/testlinesdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Testen',
                disabled: false,
                href: '/devices/tests'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-types-detail" */ './views/devices/testlines/Detail.vue'
            )
        },
        {
          path: '/devices/approvalnumbers',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Goedkeuringsnummers',
                disabled: false,
                href: '/devices/approvalnumbers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-approvalnumbers" */ './views/devices/approvals/Overview.vue'
            )
        },
        {
          path: '/devices/approvalnumbers/:id',
          name: 'devices/approvalnumbersdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Goedkeuringsnummers',
                disabled: false,
                href: '/devices/approvalnumbers'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-approvalnumbers-detail" */ './views/devices/approvals/Detail.vue'
            )
        },
        {
          path: '/devices/measuredevices',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Meettoestellen',
                disabled: false,
                href: '/devices/measuredevices'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-devices" */ './views/devices/devices/Overview.vue'
            )
        },
        {
          path: '/devices/measuredevices/:id',
          name: 'devices/measuredevicesdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Meettoestellen',
                disabled: false,
                href: '/devices/measuredevices'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-devices-detail" */ './views/devices/devices/Detail.vue'
            )
        },
        {
          path: '/devices/measurereports',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Meetrapporten',
                disabled: false,
                href: '/devices/measurereports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-reports" */ './views/devices/reports/Overview.vue'
            )
        },
        {
          path: '/devices/measurereports/:id',
          name: 'devices/measurereportsdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Meetrapporten',
                disabled: false,
                href: '/devices/measurereports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-reports-detail" */ './views/devices/reports/Detail.vue'
            )
        },
        {
          path: '/devices/files',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Bestanden',
                disabled: false,
                href: '/devices/files'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-files" */ './views/devices/files/Overview.vue'
            )
        },
        {
          path: '/devices/files/:id',
          name: 'devices/filesdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Bestanden',
                disabled: false,
                href: '/devices/files'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-files-detail" */ './views/devices/files/Detail.vue'
            )
        },
        {
          path: '/devices/certificatelayouts',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Layout Certificaten',
                disabled: false,
                href: '/devices/certificatelayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-certificatelayouts" */ './views/devices/certificatelayouts/Overview.vue'
            )
        },
        {
          path: '/devices/certificatelayouts/:id',
          name: 'devices/certificatelayoutsdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Layout Certificaten',
                disabled: false,
                href: '/devices/certificatelayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-certificatelayouts-detail" */ './views/devices/certificatelayouts/Detail.vue'
            )
        },
        {
          path: '/devices/reportlayouts',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Layout Rapporten',
                disabled: false,
                href: '/devices/reportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-reportlayouts" */ './views/devices/reportlayouts/Overview.vue'
            )
        },
        {
          path: '/devices/reportlayouts/:id',
          name: 'devices/reportlayoutsdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Layout Rapporten',
                disabled: false,
                href: '/devices/reportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-reportlayouts-detail" */ './views/devices/reportlayouts/Detail.vue'
            )
        },
        {
          path: '/devices/exportlayouts',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Layout Export',
                disabled: false,
                href: '/devices/exportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-exportlayouts" */ './views/devices/exportlayouts/Overview.vue'
            )
        },
        {
          path: '/devices/exportlayouts/:id',
          name: 'devices/exportlayoutsdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Layout Export',
                disabled: false,
                href: '/devices/exportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-exportlayouts-detail" */ './views/devices/exportlayouts/Detail.vue'
            )
        },
        {
          path: '/devices/statusupdates',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Status Aanpassingen',
                disabled: false,
                href: '/devices/statusupdates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-statusupdates" */ './views/devices/statusupdates/Overview.vue'
            )
        },
        {
          path: '/devices/servicereports',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Onderhoudsverslagen',
                disabled: false,
                href: '/devices/servicereports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-servicereports" */ './views/devices/servicereports/Overview.vue'
            )
        },
        {
          path: '/devices/servicereports/:id',
          name: 'devices/servicereportsdetail',
          meta: {
            breadCrumbs: [
              {
                text: "Camera's RLC/SNC of andere",
                disabled: true
              },
              {
                text: 'Onderhoudsverslagen',
                disabled: false,
                href: '/devices/servicereports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "devices-servicereports-detail" */ './views/devices/servicereports/Detail.vue'
            )
        },
        {
          path: '/sites/types',
          name: 'sites/types',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/sites/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-types" */ './views/sites/types/Overview.vue'
            )
        },
        {
          path: '/sites/types/:id',
          name: 'sites/typesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/sites/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-types-detail" */ './views/sites/types/Detail.vue'
            )
        },
        {
          path: '/sites/types/:type_id/lines/:id',
          name: 'sites/typelinesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/sites/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-types-lines" */ './views/sites/typelines/Detail.vue'
            )
        },
        {
          path: '/sites/reporttypes',
          name: 'sites/reporttypes',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Rapport Types',
                disabled: false,
                href: '/sites/reporttypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-reporttypes" */ './views/sites/reporttypes/Overview.vue'
            )
        },
        {
          path: '/sites/reporttypes/:id',
          name: 'sites/reporttypesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Rapport Types',
                disabled: false,
                href: '/sites/reporttypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-reporttypes-detail" */ './views/sites/reporttypes/Detail.vue'
            )
        },
        {
          path: '/sites/reporttypes/:type_id/lines/:id',
          name: 'sites/reporttypelinesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Rapport Types',
                disabled: false,
                href: '/sites/reporttypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-reporttypes-lines" */ './views/sites/reporttypelines/Detail.vue'
            )
        },
        {
          path: '/sites/sites',
          name: 'sites/sites',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Sites',
                disabled: false,
                href: '/sites/sites'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-sites" */ './views/sites/sites/Overview.vue'
            )
        },
        {
          path: '/sites/sites/:id',
          name: 'sites/sitesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Sites',
                disabled: false,
                href: '/sites/sites'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-reports-detail" */ './views/sites/sites/Detail.vue'
            )
        },
        {
          path: '/sites/reports',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Rapporten',
                disabled: false,
                href: '/sites/reports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-reports" */ './views/sites/reports/Overview.vue'
            )
        },
        {
          path: '/sites/reports/:id',
          name: 'sites/reportsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Rapporten',
                disabled: false,
                href: '/sites/reports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-reports-detail" */ './views/sites/reports/Detail.vue'
            )
        },
        {
          path: '/sites/files',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Bestanden',
                disabled: false,
                href: '/sites/files'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-files" */ './views/sites/files/Overview.vue'
            )
        },
        {
          path: '/sites/files/:id',
          name: 'sites/filesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Bestanden',
                disabled: false,
                href: '/sites/files'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-files-detail" */ './views/sites/files/Detail.vue'
            )
        },
        {
          path: '/sites/planning',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Planning',
                disabled: false,
                href: '/sites/planning'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-planning" */ './views/sites/planning/Overview.vue'
            )
        },
        {
          path: '/sites/planning/:id',
          name: 'sites/planningdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Planning',
                disabled: false,
                href: '/sites/planning'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-planning-detail" */ './views/sites/planning/Detail.vue'
            )
        },
        {
          path: '/sites/exportlayouts',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Layout Export',
                disabled: false,
                href: '/sites/exportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-exportlayouts" */ './views/sites/exportlayouts/Overview.vue'
            )
        },
        {
          path: '/sites/exportlayouts/:id',
          name: 'sites/exportlayoutsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Layout Export',
                disabled: false,
                href: '/sites/exportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-exportlayouts-detail" */ './views/sites/exportlayouts/Detail.vue'
            )
        },
        {
          path: '/sites/statusupdates',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Status Aanpassingen',
                disabled: false,
                href: '/sites/statusupdates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-statusupdates" */ './views/sites/statusupdates/Overview.vue'
            )
        },
        {
          path: '/sites/serviceorders',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Dienstbevelen',
                disabled: false,
                href: '/sites/serviceorders'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-serviceorders" */ './views/sites/serviceorders/Overview.vue'
            )
        },
        {
          path: '/sites/serviceorders/:id',
          name: 'sites/serviceordersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Dienstbevelen',
                disabled: false,
                href: '/sites/serviceorders'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-serviceorders-detail" */ './views/sites/serviceorders/Detail.vue'
            )
        },
        {
          path: '/sites/notifications',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Meldingen',
                disabled: false,
                href: '/sites/notifications'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-notifications" */ './views/sites/serviceorders/Overview.vue'
            )
        },
        {
          path: '/sites/notifications/:id',
          name: 'sites/snotificationsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Sites',
                disabled: true
              },
              {
                text: 'Meldingen',
                disabled: false,
                href: '/sites/notifications'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "sites-notifications-detail" */ './views/sites/serviceorders/Detail.vue'
            )
        },
        {
          path: '/routecontrols/types',
          name: 'routecontrols/types',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/routecontrols/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-types" */ './views/sites/types/Overview.vue'
            )
        },
        {
          path: '/routecontrols/types/:id',
          name: 'routecontrols/typesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/routecontrols/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-types-detail" */ './views/sites/types/Detail.vue'
            )
        },
        {
          path: '/routecontrols/types/:type_id/lines/:id',
          name: 'routecontrols/typelinesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Types',
                disabled: false,
                href: '/routecontrols/types'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-types-lines" */ './views/sites/typelines/Detail.vue'
            )
        },
        {
          path: '/routecontrols/reporttypes',
          name: 'routecontrols/reporttypes',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Rapport Types',
                disabled: false,
                href: '/routecontrols/reporttypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-reporttypes" */ './views/sites/reporttypes/Overview.vue'
            )
        },
        {
          path: '/routecontrols/reporttypes/:id',
          name: 'routecontrols/reporttypesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Rapport Types',
                disabled: false,
                href: '/routecontrols/reporttypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-reporttypes-detail" */ './views/sites/reporttypes/Detail.vue'
            )
        },
        {
          path: '/routecontrols/reporttypes/:type_id/lines/:id',
          name: 'routecontrols/reporttypelinesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Rapport Types',
                disabled: false,
                href: '/routecontrols/reporttypes'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-reporttypes-lines" */ './views/sites/reporttypelines/Detail.vue'
            )
        },
        {
          path: '/routecontrols/routecontrols',
          name: 'routecontrols/sites',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Traject Controles',
                disabled: false,
                href: '/routecontrols/routecontrols'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-sites" */ './views/sites/sites/Overview.vue'
            )
        },
        {
          path: '/routecontrols/routecontrols/:id',
          name: 'routecontrols/sitesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Traject Controles',
                disabled: false,
                href: '/routecontrols/routecontrols'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-sites-detail" */ './views/sites/sites/Detail.vue'
            )
        },
        {
          path: '/routecontrols/reports',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Rapporten',
                disabled: false,
                href: '/routecontrols/reports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-reports" */ './views/sites/reports/Overview.vue'
            )
        },
        {
          path: '/routecontrols/reports/:id',
          name: 'routecontrols/reportsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Rapporten',
                disabled: false,
                href: '/routecontrols/reports'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-reports-detail" */ './views/sites/reports/Detail.vue'
            )
        },
        {
          path: '/routecontrols/files',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Bestanden',
                disabled: false,
                href: '/routecontrols/files'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-files" */ './views/sites/files/Overview.vue'
            )
        },
        {
          path: '/routecontrols/files/:id',
          name: 'routecontrols/filesdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Bestanden',
                disabled: false,
                href: '/routecontrols/files'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-files-detail" */ './views/sites/files/Detail.vue'
            )
        },
        {
          path: '/routecontrols/planning',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Planning',
                disabled: false,
                href: '/routecontrols/planning'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-planning" */ './views/sites/planning/Overview.vue'
            )
        },
        {
          path: '/routecontrols/planning/:id',
          name: 'routecontrols/planningdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Planning',
                disabled: false,
                href: '/routecontrols/planning'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-planning-detail" */ './views/sites/planning/Detail.vue'
            )
        },
        {
          path: '/routecontrols/exportlayouts',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Layout Export',
                disabled: false,
                href: '/routecontrols/exportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-exportlayouts" */ './views/sites/exportlayouts/Overview.vue'
            )
        },
        {
          path: '/routecontrols/exportlayouts/:id',
          name: 'routecontrols/exportlayoutsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Layout Export',
                disabled: false,
                href: '/routecontrols/exportlayouts'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-exportlayouts-detail" */ './views/sites/exportlayouts/Detail.vue'
            )
        },
        {
          path: '/routecontrols/statusupdates',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Status Aanpassingen',
                disabled: false,
                href: '/routecontrols/statusupdates'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-statusupdates" */ './views/sites/statusupdates/Overview.vue'
            )
        },
        {
          path: '/routecontrols/serviceorders',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Dienstbevelen',
                disabled: false,
                href: '/routecontrols/serviceorders'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-serviceorders" */ './views/sites/serviceorders/Overview.vue'
            )
        },
        {
          path: '/routecontrols/serviceorders/:id',
          name: 'routecontrols/serviceordersdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Dienstbevelen',
                disabled: false,
                href: '/routecontrols/serviceorders'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-serviceorders-detail" */ './views/sites/serviceorders/Detail.vue'
            )
        },
        {
          path: '/routecontrols/notifications',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Meldingen',
                disabled: false,
                href: '/routecontrols/notifications'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-notifications" */ './views/sites/serviceorders/Overview.vue'
            )
        },
        {
          path: '/routecontrols/notifications/:id',
          name: 'routecontrols/notificationsdetail',
          meta: {
            breadCrumbs: [
              {
                text: 'Traject Controles',
                disabled: true
              },
              {
                text: 'Meldingen',
                disabled: false,
                href: '/routecontrols/notifications'
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "routecontrols-notifications-detail" */ './views/sites/serviceorders/Detail.vue'
            )
        }
      ]
    },
    {
      path: '/*',
      redirect: '/'
    }
  ]
});
